import React from 'react'
import * as Styled from './QualityIndicatorIcon.styles'
import { number, oneOfType, shape, string } from 'prop-types'

const QualityIndicatorIcon = ({ shape, value, maxValue }) => {
  const retrieveValueForIndicator = () => {
    if (value.link && value.description) {
      return (
        <Styled.QualityIndicatorCross>
          <a href={ value.link }>{value.description}</a>
        </Styled.QualityIndicatorCross>
      )
    }
    if (value === 0) {
      return <Styled.QualityIndicatorCross className='icon-f-cross' />
    }
    if (value === -1) {
      return (
        <Styled.QualityIndicatorCross>Einzelfall</Styled.QualityIndicatorCross>
      )
    }
    return [...Array(maxValue)].map((level, index) =>
      index < value ? (
        <Styled.QualityIndicatorIcon
          key={ `item-${ index }` }
          className={ `filled ${ shape === 'circle' ? 'circle' : '' }` }
        />
      ) : (
        <Styled.QualityIndicatorIcon
          key={ `item-${ index }` }
          className={ `${ shape === 'circle' ? 'circle' : '' }` }
        />
      )
    )
  }

  return (
    <Styled.QualityIndicatorIconWrapper>
      {retrieveValueForIndicator()}
    </Styled.QualityIndicatorIconWrapper>
  )
}

QualityIndicatorIcon.defaultProps = {
  shape: 'circle',
  maxValue: 5,
}

QualityIndicatorIcon.propTypes = {
  shape: string,
  value: oneOfType([
    number,
    shape({
      link: string,
      description: string,
    }),
  ]).isRequired,
  maxValue: number,
}

export default QualityIndicatorIcon
